import { AppStyle } from '../../../../app/erp/types'
import ChooseWorkingCenter from './ChooseWorkingCenter'
import { ChangeUser, NotificationsConnect, TimeControl } from '../../LeftMenu/IconMenuBar/UserIcons'
import { SearchBarWithDebounce } from '../../../SearchBar'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Routes } from '../../../CreateRoutering/types'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import SearchMenu, { useSearchMenuWithSearchBarLogic } from '../../LeftMenu/OpenedMenu/SearchMenu'
import useOnClickOutside from '../../../../utils/hooks/useOnClickOut'
import { ChangeValueFunc } from '../../../../utils/globals/types'
import { ModalOpenedTy } from '../../../Modal/types'
import User from './User'
import { MainSearch } from '../../LeftMenu/OpenedMenu'
import { faSearch } from '@fortawesome/pro-light-svg-icons'
import QuickCreateTools from './QuickCreateTools'

interface RightSideHeaderProps extends RightSideHeaderBaseProps {
    appStyle?: AppStyle
}

const RightSideHeader: React.FC<RightSideHeaderProps> = ({appStyle, routes}) => {
    const menus: Record<AppStyle, React.FC<RightSideHeaderBaseProps>> = {
        default: RightSideHeaderDefault, 
        new1: RightSideNew1
    }
    const Component = menus[appStyle || 'new1']
    return (<Component routes={routes} />)
}

interface RightSideHeaderBaseProps {
    routes: Routes
}

interface RightSideHeaderDefaultProps {}

const RightSideHeaderDefault: React.FC<RightSideHeaderDefaultProps> = () => {
    return (
        <div className='ml-auto'>
            <ChooseWorkingCenter />
        </div>
    )
}

interface RightSideNew1Props extends RightSideHeaderBaseProps {}

const RightSideNew1: React.FC<RightSideNew1Props> = ({routes}) => {
    const {t} = useTwinTranslation()
    const {handleOnChangeSearchBar, handleOnKeyDown, onChangeSearchBar, searchValue} = useSearchMenuWithSearchBarLogic()
    const { opened, onReset, setOpened, ref, openedSearchIcon} = useRightSideNew1Logic({onChangeSearchBar})
    return (
        <div className='ml-auto flex items-center right_side_new gap-x-20'>
            {openedSearchIcon ?
                <MainSearch routes={routes} icon={faSearch} /> :
                <div className='relative w-200 main_menu_search_parent' ref={ref}>
                    <SearchBarWithDebounce placeholder={t('searchDots', 'Buscar...')} searchValue={searchValue.value} onChange={onChangeSearchBar} className='text-gray-51 main_menu_search' onKeyDown={handleOnKeyDown} onFocus={() => setOpened(true)}/>
                    {opened ? <SearchMenu searchValue={searchValue} handleOnChangeSearchBar={handleOnChangeSearchBar} routes={routes} onClose={onReset} /> : null}
                </div>
            }
            <div className='right_side_divider'></div>
            <QuickCreateTools />
            <ChangeUser />
            <TimeControl onClick={() => {}} />
            <NotificationsConnect onClick={() => {}}/>
            <div className='right_side_divider'></div>
            <User />
        </div>
    )
}
interface RightSideNew1LogicProps {
    onChangeSearchBar: ChangeValueFunc
}
const useRightSideNew1Logic = ({onChangeSearchBar}: RightSideNew1LogicProps) => {
    const ref = useRef<any>(null)
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    const [openedSearchIcon, setOpenedSearchIcon] = useState<ModalOpenedTy>(true)

    const current = ref.current
    const onReset = useCallback(() => {
        onChangeSearchBar('')
        setOpened(null)
        const element = current?.querySelector('.main_menu_search input')
        element?.blur()
    }, [setOpened, onChangeSearchBar, current])
    useOnClickOutside(ref, onReset)

    const resizeSearchMenu = useCallback(() => {
        setOpenedSearchIcon(window.innerWidth > 750 ? null : true)
    }, [])

    useEffect(() => {
        resizeSearchMenu()
        window.addEventListener('resize', resizeSearchMenu)
        return () => {
            window.removeEventListener('resize', resizeSearchMenu)
        }
    }, [resizeSearchMenu])

    return { onReset, opened, setOpened, ref, openedSearchIcon}
}

export default RightSideHeader